import { mergeAttributes, Node } from "@tiptap/core";

export const Callout = Node.create<{
  HTMLAttributes: Record<string, unknown>;
}>({
  name: "callout",

  content: "block+",

  group: "block",

  defining: true,

  addOptions() {
    return {
      HTMLAttributes: {
        class:
          "flex-1 rounded-8 px-5 py-3.5 [&>h2]:mt-1.5 [&>h2]:mb-1.5 [&>h3]:mt-0.5 [&>h3]:mb-0.5 [&>h4]:mt-0 [&>h4]:mb-0",
        "data-type": "callout",
      },
    };
  },

  addAttributes() {
    return {
      color: {
        default: "yellow-100",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (node) => {
          return node.getAttribute("data-type") === "callout" ? null : false;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
});
